import { featureFlagService } from '@superbet-group/web.lib.flags';
import {
    onMounted,
    ref,
} from '@vue/composition-api';

function useLoyaltyFlag() {
    const isSupercoinsEnabled = ref(false);

    onMounted(async () => {
        isSupercoinsEnabled.value = await featureFlagService.getFeatureValue('loyalty.supercoins', false);
    });

    return {
        isSupercoinsEnabled,
    };
}

export { useLoyaltyFlag };
